import { ItemRatings, PluginProps, Rate } from './types'

export const hasRatings = (ratings: ItemRatings): boolean =>
  ratings.averageRating >= 0 && ratings.numberOfRatings > 0

export const hasUserRating = (props: PluginProps): boolean => 
  !!props.userName && !!props.currentUserRating

export const isValidRate = (num: number): num is Rate => {
  return num >= 1 && num <= 5
}
